import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { numberLocaleFromI18n } from "../../utils/i18nLocale";

const OrganigramaPrintHeader = ({ title, subtitle }) => {
  const { i18n, t } = useTranslation();

  return (
    <Box sx={{ mb: 2, pb: 1.5, borderBottom: "2px solid", borderColor: "divider" }}>
      <Typography
        variant="overline"
        sx={{ fontWeight: 700, letterSpacing: 1.2, color: "text.secondary" }}
      >
        {t("organigrama.printBrands")}
      </Typography>
      <Typography variant="h5" sx={{ fontWeight: 800, lineHeight: 1.2, mt: 0.25 }}>
        {title}
      </Typography>
      {subtitle ? (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {subtitle}
        </Typography>
      ) : null}
      <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.75 }}>
        {new Date().toLocaleDateString(numberLocaleFromI18n(i18n.language), {
          day: "numeric",
          month: "long",
          year: "numeric",
        })}
      </Typography>
    </Box>
  );
};

export default OrganigramaPrintHeader;
